var map = {
	"./article-gb-dwrg-1.jpg": "cf64",
	"./article-gb-dwrg-2.jpg": "ca59",
	"./article-gb-dwrg-3.jpg": "4070",
	"./article-gb-dwrg-4.jpg": "d393",
	"./article-gb-dwrg-5.jpg": "da54",
	"./article-gb-dwrg-6.jpg": "563e",
	"./article-gb-dwrg-7.jpg": "a0a5",
	"./article-gb-dwrg-8.jpg": "e319",
	"./article-gb-other-1.png": "3c41",
	"./article-gb-other-2.png": "8fe3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1bc4";